import { z } from "zod";

export const csmCompanySchema = z.object({
    domain: z.enum(["san-marco.com", "novacolor.it"] as const),
    id: z.string(),
    name: z.string(),
});

export type CsmCompanyDto = z.infer<typeof csmCompanySchema>;
